import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate } from 'react-router-dom'
import { IssueCategoryForm } from '@/components/forms/IssueCategoryForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function IssueCategoryCreatePage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const handleDone = () => navigate('/service-catalog/issue-categories')

  return (
    <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
      <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex="1">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Create Issue Category</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Add a new issue category, sub-category, or item
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <IssueCategoryForm onSuccess={handleDone} onCancel={handleDone} />
          </CardBody>
        </Card>
      </Box>
    </Box>
  )
}
